import React, {
  useCallback,
  useMemo,
  useState,
  useEffect,
  useRef,
} from "react";
import { Container } from "reactstrap";
import { Button, Grid, TextField, Typography } from "@mui/material";
import axios from "axios";
import { Controller, useForm } from "react-hook-form";
import { useAlert } from "react-alert";
import Checkbox from "@mui/material/Checkbox";
import { useNavigate } from "react-router-dom";
import RadioGroup from "@mui/material/RadioGroup";
import Moment from "moment";
import Select from "react-select";
import SearchIcon from "@mui/icons-material/Search";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Button.css";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import InputAdornment from "@mui/material/InputAdornment";
import PrintIcon from "@mui/icons-material/Print";
import { useReactToPrint } from "react-to-print";
import Headroom from "react-headroom";
import DialogTitle from "@mui/material/DialogTitle";

// const history = useHistory();
const OSAPAGE = (props) => {
  // const patiname = props.PatientName;
  // const Formdidi = props.formDid;
  const [Formdid, setFormdid] = useState(
    props.formDid !== undefined ? props.formDid : 0,
  );
  const [columnID, setcolumnID] = useState(
    props.columnID !== undefined ? props.columnID : 0,
  );
  const [AutpattientID, setAutpattientID] = useState(props.AutpattientID);
  console.log("test", AutpattientID);
  // const patientId = props.patientId;
  const patientId =
    props.callingFrom == "update" ? props.patientid : props.patientId;
  const [patientName, setpatientName] = useState(
    props.callingFrom == "OSARequest" || props.callingFrom == "Images"
      ? props.OSARequestpatientName
      : props.patientName,
  );

  // const [patientName, setpatientName] = useState(props.patientName);
  console.log("paaa", patientName);

  const pname = props.PatientName;
  const [careProvDate, setCareProvDate] = React.useState(
    Moment().format("YYYY-MM-DD"),
  );
  const [datee, setDatee] = React.useState("");
  const [consentDatee, setConsentDate] = React.useState(
    Moment().format("YYYY-MM-DD"),
  );
  const [idd, setIdd] = useState("");
  const [patId, setPatId] = useState("");
  const [patName, setPatName] = useState(pname);
  const [insuName, setInsuName] = useState("");
  const [insuId, setInsuId] = useState("");
  const [Address, setAddresses] = useState("");
  // const Address = props.callingFrom=="Pateint"? props.Address:addresses;
  const [city, setCity] = useState("");
  const [states, setStates] = useState("");
  const [zipCodes, setZipCodes] = useState("");
  const [phones, setPhones] = useState("");
  const [heartProblems, setHeartProblems] = useState();
  const [heartPDetails, setHeartPDetails] = useState("");
  const [highBloodP, setHighBloodP] = useState();
  const [bloodPDetails, setBloodPDetails] = useState("");
  const [diabetes, setDiabetes] = useState();
  const [diabetesDetail, setDiabetesDetail] = useState("");
  const [thyroidSynd, setThyroidSynd] = useState("");
  const [thyroidSyndDetail, setThyroidSyndDetail] = useState("");
  const [presMeds, setPresMeds] = useState("");
  const [presMedDetails, setPresMedDetails] = useState("");
  const [attachList, setAttachList] = useState("");
  const [alcoholCon, setAlcoholCon] = useState("");
  const [smokingLevel, setSmokingLevel] = useState("");
  const [sleepiness, setSleepiness] = useState("");
  const [impairedCog, setImpairedCog] = useState();
  const [insomnia, setInsomnia] = useState();
  const [heartDisease, setHeartDisease] = useState("");
  const [inapprop, setInapprop] = useState("");
  const [excessives, setExcessives] = useState("");
  const [moodDisorders, setMoodDisorders] = useState("");
  const [hypertension, setHypertension] = useState("");
  const [historyStroke, setHistoryStroke] = useState("");
  const [cpap, setCpap] = useState("");
  const [cpap1, setCpap1] = useState("");

  const [cpapLimit, setCpapLimit] = useState("");
  const [deviceCausing, setDeviceCausing] = useState("");
  const [deviceIrritated, setDeviceIrritated] = useState("");
  const [intestIssues, setIntestIssues] = useState("");
  const [others, setOthers] = useState("");
  const [latexAllergy, setLatexAllergy] = useState("");
  const [prevSleep, setPrevSleep] = useState("");
  const [ahiScore, setAhiScore] = useState("");
  const [ahi, setAhi] = useState("");
  const [oralSleepAppl, setOralSleepAppl] = useState("");
  const [oralSleepYear, setOralSleepYear] = useState("");
  const [sitReading, setSitReading] = useState("");
  const [watchingTV, setWatchingTV] = useState("");
  const [sitPlace, setSitPlace] = useState("");
  const [passengerCar, setPassengerCar] = useState("");
  const [layingToRest, setLayingToRest] = useState("");
  const [sitTalking, setSitTalking] = useState("");
  const [sitQuietly, setSitQuietly] = useState("");
  const [consumed, setConsumed] = useState("");
  const [carStationary, setCarStationary] = useState("");
  const [pSig, setPSig] = useState("");
  const [periodCondition, setPeriodCondition] = useState("");
  const [tonsilsEnlarged, setTonsilsEnlarged] = useState("");
  const [grindingOfTeeth, setGrindingOfTeeth] = useState("");
  const [palpitation, setPalpitation] = useState("");
  const [mandiMovement, setMandiMovement] = useState("");
  const [smoothMovement, setSmoothMovement] = useState("");
  const [luxation, setLuxation] = useState("");
  const [tenPlus, setTenPlus] = useState("");
  const [feelFatigued, setFeelFatigued] = useState("");
  const [notUsingCPAP, setNotUsingCPAP] = useState("");
  const [headaches, setHeadaches] = useState("");
  const [daytimeNapping, setDaytimeNapping] = useState("");
  const [provName, setProvName] = useState("");
  const [provSig, setProvSig] = useState("");
  const [patDOB, setPatDOB] = useState("");
  const [orderPhyName, setOrderPhyName] = useState("");
  const [necessityPat, setNecessityPat] = useState("");
  const [inactivve, setInactivve] = useState("");
  const [pracId, setPracId] = useState("");
  const [maxOp, setMaxOp] = useState("");
  const [maxProt, setMaxProt] = useState("");
  const [leftMovements, setLeftMovements] = useState("");
  const [rightMovements, setRightMovements] = useState("");
  const [consentSig, setConsentSig] = useState("");
  const [prName, setPrName] = useState("");
  const [totals, setTotal] = useState("");

  const [suggestions, setSuggestions] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [openInsurances, setOpenInsurances] = useState(false);
  const [insuranceNames, setInsuranceNames] = React.useState([]);

  const fields = [
    "id",
    "patientName",
    "patientId",
    "insuranceName",
    "insurancId",
    "address",
    "city",
    "state",
    "zipCode",
    "phone",
    "heartProblems",
    "heartProblemsDetails",
    "highBloodPressure",
    "highBloodPressureDetails",
    "diabetes",
    "diabetesDetail",
    "thyroidSyndrome",
    "thyroidSyndromeDeatils",
    "prescribedMedicines",
    "prescribedMedicinesDetails",
    "attachList",
    "alcoholConsumption",
    "smokingLevel",
    "sleepiness",
    "impairedCognition",
    "insomnia",
    "ischemicHeartDisease",
    "inappropriate",
    "excessive",
    "moodDisorders",
    "hypertension",
    "historyOfStroke",
    "cpap",
    "cpap1",
    "cpapDaysLimit",
    "deviceCausing",
    "deviceIrritated",
    "intestinalissues",
    "other",
    "latexAllergy",
    "previousSleepStudy",
    "ahiScore",
    "oralSleepAppliance",
    "oralSleepYear",
    "sittingAndReading",
    "watchingTV",
    "sittingInactivePlace",
    "passengerCar",
    "layingToRest",
    "sittingAndTalking",
    "sittingQuietly",
    "consumed",
    "carStationary",
    "patientSignature",
    "sleepinessDate",
    "periodontalCondition",
    "tonsilsEnlarged",
    "grindingOfTeeth",
    "palpitation",
    "mandibularMovement",
    "smoothMovement",
    "luxation",
    "epworthOfTenPlus",
    "feelingFatigued",
    "notUsingCPAP",
    "headaches",
    "inappropriateDaytimeNapping",
    "ahi",
    "providerCareName",
    "providerCareSignature",
    "careProviderDate",
    "orderingPhysicianName",
    "necessityPatient",
    "patDOB",
    "inactive",
    "practiceId",
    "maxOpening",
    "maxProtrusion",
    "maxLateralLeftMovements",
    "maxLateralRightMovements",
    "consentDate",
    "consentSignature",
    "printName",
    "total",
    "comments",
    "createdBy",
    "createdDate",
  ];
  const defValues = {
    id: 0,
    patientId: patientId,
    patientName: "",
    insuranceName: "",
    insurancId: 0,
    address: "",
    city: "",
    state: "",
    zipCode: "",
    phone: "",
    heartProblems: "",
    heartProblemsDetails: "",
    highBloodPressure: "",
    highBloodPressureDetails: "",
    diabetes: "",
    diabetesDetail: "",
    thyroidSyndrome: "",
    thyroidSyndromeDeatils: "",
    prescribedMedicines: true,
    prescribedMedicinesDetails: "",
    attachList: "",
    alcoholConsumption: "",
    smokingLevel: "",
    sleepiness: false,
    impairedCognition: "",
    insomnia: "",
    ischemicHeartDisease: "",
    inappropriate: "",
    excessive: false,
    moodDisorders: "",
    hypertension: "",
    historyOfStroke: "",
    cpap: "",
    cpap1: "",
    cpapDaysLimit: "",
    deviceCausing: "",
    deviceIrritated: "",
    intestinalissues: "",
    other: "",
    latexAllergy: "",
    previousSleepStudy: "",
    ahiScore: "",
    oralSleepAppliance: "",
    oralSleepYear: "",
    sittingAndReading: "",
    watchingTV: "",
    sittingInactivePlace: "",
    passengerCar: "",
    layingToRest: "",
    sittingAndTalking: "",
    sittingQuietly: "",
    consumed: "",
    carStationary: "",
    patientSignature: "",
    sleepinessDate: "",
    periodontalCondition: "",
    tonsilsEnlarged: "",
    grindingOfTeeth: "",
    palpitation: "",
    mandibularMovement: "",
    smoothMovement: "",
    luxation: "",
    epworthOfTenPlus: "",
    feelingFatigued: "",
    notUsingCPAP: "",
    headaches: "",
    inappropriateDaytimeNapping: "",
    ahi: "",
    providerCareName: "",
    providerCareSignature: "",
    careProviderDate: "",
    orderingPhysicianName: "",
    necessityPatient: "",
    patDOB: "",
    inactive: true,
    practiceId: 0,
    maxOpening: 0,
    maxProtrusion: 0,
    maxLateralLeftMovements: 0,
    maxLateralRightMovements: 0,
    consentDate: "",
    consentSignature: "",
    printName: "",
    total: "",
    comments: "",
    createdDate: "",
    createdBy: "",
  };

  const navigate = useNavigate();
  const [printpage, setPrintPage] = useState(false);
  const printRef1 = useRef();
  const handlePrint1 = useReactToPrint({
    content: () => printRef1.current,
    onBeforeGetContent: () => {
      setPrintPage(true);
    },
    onAfterPrint: () => {
      setPrintPage(false);
    },
  });

  useEffect(() => {
    console.log("printRef1 in useEffect:", printRef1.current);
    if (printpage) {
      // Delay the execution to ensure the printing content is ready
      handlePrint1();
    }
  }, [printpage]);
  const alert = useAlert();
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };

  const {
    register,
    control,
    handleSubmit,
    getValues,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    delayError: undefined,
    // resolver: yupResolver(validationSchema),
    defaultValues: defValues,
  });

  const [submitting, setSubmitting] = useState(false);
  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/AutherizationRequest/ObstructiveSleepApneaById?Id=${Formdid}&authId=${columnID}`,
        { headers },
      )
      .then((response) => {
        fields.forEach((field) => {
          setValue(field, response[field]);
        });

        console.log("response.dataaaaa: ", response);
        setIdd(response.id);
        setPatId(response.patientId);
        setPatName(response.patientName);
        setInsuName(response.insuranceName);
        setInsuId(response.insurancId);
        setAddresses(response.address);
        setCity(response.city);
        setStates(response.state);
        setZipCodes(response.zipCode);
        setPhones(response.phone);
        setHeartProblems(response.heartProblems);
        setHeartPDetails(response.heartProblemsDetails);
        setHighBloodP(response.highBloodPressure);
        setBloodPDetails(response.highBloodPressureDetails);
        setDiabetes(response.diabetes);
        setDiabetesDetail(response.diabetesDetail);
        setThyroidSynd(response.thyroidSyndrome);
        // setThyroidSynd(response.thyroidSyndromeDeatils)
        setPresMeds(response.prescribedMedicines);
        setPresMedDetails(response.prescribedMedicinesDetails);
        setAttachList(response.attachList);
        setAlcoholCon(response.alcoholConsumption);
        setSmokingLevel(response.smokingLevel);
        setSleepiness(response.sleepiness);
        setImpairedCog(response.impairedCognition);
        setInsomnia(response.insomnia);
        setHeartDisease(response.ischemicHeartDisease);
        setInapprop(response.inappropriate);
        setExcessives(response.excessive);
        setMoodDisorders(response.moodDisorders);
        setHypertension(response.hypertension);
        setHistoryStroke(response.historyOfStroke);
        setCpap(response.cpap);
        setCpap1(response.cpap1);

        setCpapLimit(response.cpapDaysLimit);
        setDeviceCausing(response.deviceCausing);
        setDeviceIrritated(response.deviceIrritated);
        setIntestIssues(response.intestinalissues);
        setOthers(response.other);
        setLatexAllergy(response.latexAllergy);
        setPrevSleep(response.previousSleepStudy);
        setAhiScore(response.ahiScore);
        setAhi(response.ahi);
        setOralSleepAppl(response.oralSleepAppliance);
        setOralSleepYear(response.oralSleepYear);
        setSitReading(response.sittingAndReading);
        setWatchingTV(response.watchingTV);
        setSitPlace(response.sittingInactivePlace);
        setPassengerCar(response.passengerCar);
        setLayingToRest(response.layingToRest);
        setSitTalking(response.sittingAndTalking);
        setSitQuietly(response.sittingQuietly);
        setConsumed(response.consumed);
        setCarStationary(response.carStationary);
        setPSig(response.patientSignature);
        setPeriodCondition(response.periodontalCondition);
        setTonsilsEnlarged(response.tonsilsEnlarged);
        setGrindingOfTeeth(response.grindingOfTeeth);
        setPalpitation(response.palpitation);
        setMandiMovement(response.mandibularMovement);
        setSmoothMovement(response.smoothMovement);
        setLuxation(response.luxation);
        setTenPlus(response.epworthOfTenPlus);
        setFeelFatigued(response.feelingFatigued);
        setNotUsingCPAP(response.notUsingCPAP);
        setHeadaches(response.headaches);
        setDaytimeNapping(response.inappropriateDaytimeNapping);
        setProvName(response.providerCareName);
        setProvSig(response.providerCareSignature);
        setOrderPhyName(response.orderingPhysicianName);
        setNecessityPat(response.necessityPatient);
        // var PattDob = Moment(response.patDOB).format('YYYY-MM-DD')
        setPatDOB(response.patDOB);
        setInactivve(response.inactive);
        setPracId(response.practiceId);
        setMaxOp(response.maxOpening);
        setMaxProt(response.maxProtrusion);
        setLeftMovements(response.maxLateralLeftMovements);
        setRightMovements(response.maxLateralRightMovements);
        setConsentSig(response.consentSignature);
        setPrName(response.printName);
        setTotal(response.total);
        if (response.sleepinessDate) {
          var PattDob2 = Moment(response.sleepinessDate).format("YYYY-MM-DD");
          setDatee(PattDob2);
        } else {
          setDatee("");
        }

        var PattDob1 = Moment(response.careProviderDate).format("YYYY-MM-DD");
        setCareProvDate(PattDob1);

        var conscDob = Moment(response.consentDate.format("YYYY-MM-DD"));
        setConsentDate(conscDob);
      })

      .catch((error) => {
        console.error("There was an error!", error);
      });

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [Formdid, patId, columnID]);
  const onSubmit = (data) => {
    setSubmitting(true);
    const postData = data;
    postData.total = Total;
    postData.sleepinessDate = datee;
    console.log("postData", postData);
    postData.authId = columnID;
    {
      props.callingFrom == "Patient"
        ? (postData.patientName = patientName)
        : (postData.patientName = pname);
    }
    {
      props.callingFrom == "Patient"
        ? (postData.patientId = AutpattientID)
        : (postData.patientId = patientId);
    }
    {
      props.callingFrom == "Patient"
        ? (postData.id = idd)
        : (postData.id = idd);
    }
    // postData.patientName= patientName
    // postData.patientId = AutpattientID
    // postData.address = Address;
    console.log("check Data", postData);
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/AutherizationRequest/AddObstructiveSleepApnea`,
        postData,
        {
          headers,
        },
      )
      .then((response) => {
        if (response.id) {
          console.log("check Data", response);
          setSubmitting(false);
          toast.success("Record saved successfully", {
            position: "bottom-center",
            // autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
            onClose: () => {
              if (props.callingFrom == "Patient") {
                props.updateHealthHistory(
                  response.id,
                  response.authId,
                  response.createdBy,
                  response.createdDate,
                );

                props.handleClose1();
                console.log("checkid", response.id);
              } else if (props.callingFrom == "OSARequest") {
                // props.updateHealthHistory(response.id, response.authId, response.patientName)
                props.updateHealthHistory(response.id, response.authId);

                props.handleClose1();
              } else if (props.callingFrom == "update") {
                // props.updateHealthHistory(response.id, response.authId, response.patientName)
                props.closevobpage();
              } else if (props.callingFrom == "dashboard") {
                props.updateHealthHistory(
                  response.id,
                  response.authId,
                  response.patientName,
                );
                // props.closevobpage()
              } else {
                props.closeosapage();
              }
            },
          });
        } else {
          setSubmitting(false);
        }
      })
      .catch((error) => {
        setSubmitting(false);
        alert.success(`Error ${error.message}`, {
          type: "error",
        });
      });
  };

  const zipCodeListStyle = {
    cursor: "pointer",
    "&:hover": {
      background: "#3b3b3b !important",
      color: "rgba(5, 152, 236, 0.637) !important",
    },
  };
  const inputProps = ["id", "insuranceName"];

  const onchangeinsurce = async (value) => {
    setOpenInsurances(true);

    axios
      .get(
        `${process.env.REACT_APP_API_URL}/Insurances/getInsuranceByName?Name=${value}`,
        { headers, inputProps },
      )
      .then((response) => {
        setOpenInsurances(true);
        setInsuranceNames(response);
      })
      .catch((error) => {
        console.error("Error fetching insurance suggestions:", error);
      });
  };
  const [patientinsurancename, setpatientinsurancename] = useState("");
  const [patientiaddress, setpatientaddress] = useState("");
  const [patientphone, setpatientphone] = useState("");
  const [patientcity, setpatientcity] = useState("");
  const [patientsate, setpatientsate] = useState("");
  const [patientzipcode, setpatientzipcode] = useState("");

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/Patients/SearchInsuranceName?patientId=${AutpattientID}`,
        {
          headers,
        },
      )
      .then((response) => {
        // console.log('testname',response[0].dob)
        const Data = response[0];
        var dateYMD = Moment(Data.dob).format("YYYY-MM-DD");
        // setpatientdob(dateYMD)
        // setpatientdob(response.dob)
        // setpatientdob(Moment(response.dob).format('YYYY-MM-DD'));

        setpatientinsurancename(Data.planName);
        setpatientcity(Data.city);
        setpatientsate(Data.state);
        setpatientzipcode(Data.zipCode);

        setpatientaddress(Data.address);
        setpatientphone(Data.phoneNumber);

        // setRefresh(!refresh)
      })

      .catch((error) => {
        console.error("There was an error!", error);
      });
  }, [AutpattientID]);

  const values = watch();

  const calculateTotal = () => {
    const fieldse = getValues([
      "watchingTV",
      // sitReading,
      "sittingAndReading",
      "sittingInactivePlace",
      "passengerCar",
      "layingToRest",
      "sittingAndTalking",
      "sittingQuietly",
      "carStationary",
    ]);

    return Object.values(fieldse).reduce(
      (total, value) => total + (parseInt(value) || 0),
      0,
    );
  };
  const Total = calculateTotal();
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
           <Grid item xs={11}></Grid>
                  <Grid item xs={1}>
                               <PrintIcon
                                 onClick={handlePrint1}
                                 fontSize="large"
                                 style={{
                                   color: "white",
                                   paddingRight: "5px",
                                   cursor: "pointer",
                                   float: "right",
                                   color: "356F60",
                                 }}
                               ></PrintIcon>
                             </Grid>
      <Grid container spacing={3} sx={{p:3}} ref={printRef1}>

        <Grid item xs={12}>
          <Typography
            variant="h4"
            align="center"
            fontWeight="bold"
            color="primary"
            gutterBottom
          >
            Snoring and Obstructive Sleep Apnea (OSA) Screener
          </Typography>

          <Typography variant="body1" align="center" sx={{ mb: 3 }}>
            Snoring and daytime sleepiness can have a profound impact on quality
            of life:
          </Typography>

          <Grid container spacing={1} sx={{ mb: 3 }}>
            {[
              {
                title: "• Daytime sleepiness",
                desc: "- less effectiveness at work and increased risk of accidents",
              },
              {
                title: "• Reduced energy-poor",
                desc: "motivation to exercise and weight gain",
              },
              {
                title: "• Relationship issues",
                desc: "- sleeping in different bedrooms, reduced sex life, and higher stress levels",
              },
              {
                title: "• Hypertension",
                desc: "- those who snore or suffer from OSA have an elevated risk of high blood pressure",
              },
            ].map((item, idx) => (
              <Grid item xs={12} key={idx}>
                <Typography variant="body2">
                  <strong>{item.title}</strong> {item.desc}
                </Typography>
              </Grid>
            ))}
          </Grid>

          <Typography
            variant="body2"
            sx={{ fontStyle: "italic", textAlign: "center", mb: 4 }}
          >
            OSA is a serious condition in which a person stops breathing (or
            suffers extremely low oxygen levels) while asleep. It often occurs
            in conjunction with snoring.
          </Typography>
        </Grid>

        <Grid
          container
          spacing={3}
          sx={{
            p: 3,
            backgroundColor: "#f8f9fa",
            borderRadius: 2,
            width: "100%",
            mx: "auto",
          }}
        >
          <Grid item xs={12}>
            <Typography
              variant="h6"
              fontWeight="bold"
              color="primary"
              gutterBottom
            >
              Patient Information
            </Typography>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                value={
                  props.callingFrom == "Patient" ||
                  props.callingFrom == "OSARequest" ||
                  props.callingFrom == "Images"
                    ? patientName
                    : patName
                }
                label="Patient Name"
                fullWidth
                variant="outlined"
                size="small"
                InputProps={{ readOnly: true }}
              />
            </Grid>

              <Grid item xs={6}>
              <TextField
                value={patientinsurancename}
                label="Insurance"
                fullWidth
                variant="outlined"
                size="small"
                InputProps={{ readOnly: true }}
              />
            </Grid>

              <Grid item xs={6}>
              <TextField
                value={patientiaddress}
                label="Address"
                fullWidth
                variant="outlined"
                size="small"
                InputProps={{ readOnly: true }}
              />
            </Grid>

              <Grid item xs={6}>
              <TextField
                label="Phone #"
                fullWidth
                variant="outlined"
                size="small"
                InputProps={{ readOnly: true }}
                value={patientphone}
              />
            </Grid>

             <Grid item xs={4}>
              <TextField
                label="City"
                fullWidth
                variant="outlined"
                size="small"
                InputProps={{ readOnly: true }}
                value={patientcity}
              />
            </Grid>

             <Grid item xs={4}>
              <TextField
                label="State"
                fullWidth
                variant="outlined"
                size="small"
                InputProps={{ readOnly: true }}
                value={patientsate}
              />
            </Grid>

             <Grid item xs={4}>
              <TextField
                label="Zip Code"
                fullWidth
                variant="outlined"
                size="small"
                InputProps={{ readOnly: true }}
                value={patientzipcode}
              />
            </Grid>
          </Grid>
        </Grid>
     
           <Grid
          container
          spacing={3}
          sx={{
            p: 3,
            backgroundColor: "#f8f9fa",
            borderRadius: 2,
            width: "100%",
            mx: "auto",
          }}
        >
          <Grid item xs={12}>
            <Typography
              variant="h6"
              fontWeight="bold"
              color="primary"
              gutterBottom
            >
              Lifestyle and General Health
            </Typography>
            <Typography variant="body2" sx={{ mb: 3 }}>
              The following questions relate to your lifestyle and general
              health. Please indicate whether you suffer from any of the below,
              providing further details when the answer is yes.
            </Typography>
          </Grid>

          {/* Heart Problems */}
          <Grid item xs={6}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <Typography variant="body2" >
                Heart problems
              </Typography>
                   <div style={{ display: "flex", gap: 15 }}>
                <input
                  type="radio"
                  name="heartProblems"
                  checked={heartProblems ? true : false}
                  onClick={(e) => {
                    setValue("heartProblems", true);
                    setHeartProblems(true);
                  }}
                  // {...register("heartProblems")}
                 
                />{" "}
                Yes
                <input
                  type="radio"
                  checked={heartProblems ? false : true}
                  onClick={(e) => {
                    setValue("heartProblems", false);
                    setHeartProblems(false);
                  }}
                />{" "}
                No
              </div>
            </div>
          </Grid>
          <Grid item xs={4}>
            <Controller
              name="heartProblemsDetails"
              {...register("heartProblemsDetails")}
              control={control}
              render={({ field }) => (
                <TextField
                  size="small"
                  variant="standard"
                  {...field}
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={6}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <Typography variant="body2" >
                High blood pressure
              </Typography>
              <div>
                <input
                  type="radio"
                  checked={highBloodP ? true : false}
                  onClick={(e) => {
                    console.log("checked value", e);
                    setValue("highBloodPressure", true);
                    setHighBloodP(true);
                  }}
                />{" "}
                Yes
                <input
                  type="radio"
                  checked={highBloodP ? false : true}
                  onClick={(e) => {
                    setValue("highBloodPressure", false);
                    setHighBloodP(false);
                  }}
                />{" "}
                No
              </div>
            </div>
          </Grid>
          <Grid item xs={4}>
            <Controller
              name="highBloodPressureDetails"
              {...register("highBloodPressureDetails")}
              control={control}
              render={({ field }) => (
                <TextField
                  size="small"
                  variant="standard"
                  {...field}
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={6}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <Typography variant="body2" >
                Diabetes
              </Typography>
              <div>
                <input
                  type="radio"
                  checked={diabetes ? true : false}
                  onClick={(e) => {
                    console.log("checked value", e);
                    setValue("diabetes", true);
                    setDiabetes(true);
                  }}
                />{" "}
                Yes
                <input
                  type="radio"
                  checked={diabetes ? false : true}
                  onClick={(e) => {
                    setValue("diabetes", false);
                    setDiabetes(false);
                  }}
                />{" "}
                No
              </div>
            </div>
          </Grid>
          <Grid item xs={4}>
            <Controller
              name="diabetesDetail"
              {...register("diabetesDetail")}
              control={control}
              render={({ field }) => (
                <TextField
                  size="small"
                  variant="standard"
                  {...field}
                  fullWidth
                />
              )}
            />
          </Grid>

          <Grid item xs={6}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <Typography variant="body2" >
                Thyroid syndrome
              </Typography>
              <div>
                <input
                  type="radio"
                  checked={thyroidSynd ? true : false}
                  onClick={(e) => {
                    console.log("checked value", e);
                    setValue("thyroidSyndrome", true);
                    setThyroidSynd(true);
                  }}
                />{" "}
                Yes
                <input
                  type="radio"
                  checked={thyroidSynd ? false : true}
                  onClick={(e) => {
                    setValue("thyroidSyndrome", false);
                    setThyroidSynd(false);
                  }}
                />{" "}
                No
              </div>
            </div>
          </Grid>
          <Grid item xs={4}>
            <Controller
              name="thyroidSyndromeDeatils"
              {...register("thyroidSyndromeDeatils")}
              control={control}
              render={({ field }) => (
                <TextField
                  size="small"
                  variant="standard"
                  {...field}
                  fullWidth
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sx={{ mt: 3 }}>
            <Typography variant="body2" >
              Do you take any prescribed medicines? <br />
              Have you tried a Nasal CPAP
            </Typography>
            <Controller
              name="prescribedMedicinesDetails"
              {...register("prescribedMedicinesDetails")}
              control={control}
              render={({ field }) => (
                <TextField
                  size="small"
                  placeholder="Plesae Enter prescribed medicines"
                  variant="standard"
                  rows={2}
                  multiline
                  {...field}
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sx={{ mt: 3 }}>
            <Typography variant="body2" >
              <h5>Please list:</h5>
              <br />
              Have you tried a Nasal CPAP
            </Typography>
            <Controller
              name="attachList"
              {...register("attachList")}
              control={control}
              render={({ field }) => (
                <TextField
                  size="small"
                  variant="standard"
                  placeholder="Please Attach The List"
                  multiline
                  rows={3}
                  {...field}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <b>(attach if needed)</b>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sx={{ mt: 3 }}>
            <Typography variant="body2" >
              <h5>Alcohol consumption</h5>
              <br />
              Have you tried a Nasal CPAP
            </Typography>
            <Controller
              name="alcoholConsumption"
              {...register("alcoholConsumption")}
              control={control}
              render={({ field }) => (
                <TextField
                  size="small"
                  variant="standard"
                  multiline
                  placeholder="Please Enter The Alcohol Comsuption"
                  rows={3}
                  {...field}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <b>units/week</b>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sx={{ mt: 3 }}>
            <Typography variant="body2" >
              <h5>Smoking level</h5>
              <br />
              Have you tried a Nasal CPAP
            </Typography>
            <Controller
              name="smokingLevel"
              {...register("smokingLevel")}
              control={control}
              render={({ field }) => (
                <TextField
                  size="small"
                  variant="standard"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <b>no/day</b>
                      </InputAdornment>
                    ),
                  }}
                  placeholder="Smoking Level..."
                  multiline
                  rows={3}
                  {...field}
                  fullWidth
                />
              )}
            />
          </Grid>
        </Grid>

        {/* Medical Conditions Section */}
        <Grid
          container
            spacing={3}
          sx={{
            p: 3,
            backgroundColor: "#f8f9fa",
            borderRadius: 2,
            width: "100%",
            mx: "auto",
          }}
        >
          <Grid item xs={12}>
            <Typography
              variant="h6"
              fontWeight="bold"
              color="primary"
              gutterBottom
            >
              Please indicate if you have suffered from any of the conditions
              below:
            </Typography>
          </Grid>

          <Grid container spacing={2}>
            {/* Sleepiness that interferes with daily activities */}
              <Grid item xs={6}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  cursor: "pointer",
                }}
              >
                <Checkbox
                  name="sleepiness"
                  checked={sleepiness ? true : false}
                  onClick={() => {
                    setValue("sleepiness", !sleepiness);
                    setSleepiness(!sleepiness);
                  }}
                />
                <Typography variant="body2">
                  Sleepiness that interferes with daily activities
                </Typography>
              </div>
            </Grid>

            {/* Excessive daytime sleepiness */}
              <Grid item xs={6}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  cursor: "pointer",
                }}
              >
                <Checkbox
                  name="excessive"
                  checked={excessives ? true : false}
                  onClick={() => {
                    setValue("excessive", !excessives);
                    setExcessives(!excessives);
                  }}
                />
                <Typography variant="body2">
                  Excessive daytime sleepiness
                </Typography>
              </div>
            </Grid>

            {/* Impaired cognition */}
              <Grid item xs={6}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  cursor: "pointer",
                }}
              >
                <Checkbox
                  name="impairedCognition"
                  checked={impairedCog ? true : false}
                  onClick={() => {
                    setValue("impairedCognition", !impairedCog);
                    setImpairedCog(!impairedCog);
                  }}
                />
                <Typography variant="body2">Impaired cognition</Typography>
              </div>
            </Grid>

            {/* Mood disorders */}
              <Grid item xs={6}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  cursor: "pointer",
                }}
              >
                <Checkbox
                  name="moodDisorders"
                  checked={moodDisorders ? true : false}
                  onClick={() => {
                    setValue("moodDisorders", !moodDisorders);
                    setMoodDisorders(!moodDisorders);
                  }}
                />
                <Typography variant="body2">Mood disorders</Typography>
              </div>
            </Grid>

            {/* Insomnia */}
              <Grid item xs={6}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  cursor: "pointer",
                }}
              >
                <Checkbox
                  name="insomnia"
                  checked={insomnia ? true : false}
                  onClick={() => {
                    setValue("insomnia", !insomnia);
                    setInsomnia(!insomnia);
                  }}
                />
                <Typography variant="body2">Insomnia</Typography>
              </div>
            </Grid>

            {/* Hypertension */}
              <Grid item xs={6}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  cursor: "pointer",
                }}
              >
                <Checkbox
                  name="hypertension"
                  checked={hypertension ? true : false}
                  onClick={() => {
                    setValue("hypertension", !hypertension);
                    setHypertension(!hypertension);
                  }}
                />
                <Typography variant="body2">Hypertension</Typography>
              </div>
            </Grid>

            {/* Ischemic heart disease */}
              <Grid item xs={6}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  cursor: "pointer",
                }}
              >
                <Checkbox
                  name="ischemicHeartDisease"
                  checked={heartDisease ? true : false}
                  onClick={() => {
                    setValue("ischemicHeartDisease", !heartDisease);
                    setHeartDisease(!heartDisease);
                  }}
                />
                <Typography variant="body2">Ischemic heart disease</Typography>
              </div>
            </Grid>

            {/* History of stroke */}
              <Grid item xs={6}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  cursor: "pointer",
                }}
              >
                <Checkbox
                  name="historyOfStroke"
                  checked={historyStroke ? true : false}
                  onClick={() => {
                    setValue("historyOfStroke", !historyStroke);
                    setHistoryStroke(!historyStroke);
                  }}
                />
                <Typography variant="body2">History of stroke</Typography>
              </div>
            </Grid>

            {/* Inappropriate daytime napping */}
              <Grid item xs={6}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  cursor: "pointer",
                }}
              >
                <Checkbox
                  name="inappropriateDaytimeNapping"
                  checked={daytimeNapping ? true : false}
                  onClick={() => {
                    setValue("inappropriateDaytimeNapping", !daytimeNapping);
                    setDaytimeNapping(!daytimeNapping);
                  }}
                />
                <Typography variant="body2">
                  Inappropriate daytime napping (e.g., during driving,
                  conversation, or eating)
                </Typography>
              </div>
            </Grid>
          </Grid>
        </Grid>

        {/* CPAP Information Section */}
        <Grid
          container
          spacing={3}
          sx={{
            p: 3,
            backgroundColor: "#f8f9fa",
            borderRadius: 2,
            width: "100%",
            mx: "auto",
          }}
        >
          <Grid item xs={12}>
            <Typography
              variant="h6"
              fontWeight="bold"
              color="primary"
              gutterBottom
            >
              CPAP Information
            </Typography>
          </Grid>

          {/* Tried CPAP */}
          <Grid item xs={12}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <Typography variant="body2" >
                Have you tried a Nasal CPAP?
              </Typography>
              <input
                type="radio"
                checked={cpap1 ? true : false}
                onClick={(e) => {
                  console.log("checked value", e);
                  setValue("cpap1", true);
                  setCpap1(true);
                }}
              />{" "}
              Yes
              <input
                type="radio"
                checked={cpap1 ? false : true}
                onClick={(e) => {
                  setValue("cpap1", false);
                  setCpap1(false);
                }}
              />{" "}
              No
            </div>
          </Grid>

          {cpap1 === true && (
            <>
              {/* Using CPAP */}
              <Grid item xs={12}>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <Typography variant="body2" >
                    Are you currently using CPAP?
                  </Typography>
                  <input
                    type="radio"
                    checked={cpap ? true : false}
                    onClick={(e) => {
                      console.log("checked value", e);
                      setValue("cpap", true);
                      setCpap(true);
                    }}
                  />{" "}
                  Yes
                  <input
                    type="radio"
                    checked={cpap ? false : true}
                    onClick={(e) => {
                      setValue("cpap", false);
                      setCpap(false);
                    }}
                  />{" "}
                  No
                </div>
              </Grid>

              {cpap === true && (
                    <>
                  <Grid
                    item
                    xs={9}
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <h6 style={{ whiteSpace: "nowrap" }}>
                      If Yes using CPAP How many days a week?
                    </h6>

                    <Controller
                      name="cpapDaysLimit"
                      {...register("cpapDaysLimit")}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          size="small"
                          variant="standard"
                          {...field}
                          fullWidth
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <Controller
                      name="deviceCausing"
                      {...register("deviceCausing")}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          size="small"
                          variant="standard"
                          {...field}
                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={4.5} style={{ marginTop: "10px" }}>
                    <h6>Device causing claustrophobia or panic attacks</h6>
                  </Grid>

                  <Grid item xs={4}>
                    <Controller
                      name="deviceIrritated"
                      {...register("deviceIrritated")}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          size="small"
                          variant="standard"
                          {...field}
                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6} style={{ marginTop: "10px" }}>
                    <h6>
                      The CPAP device irritated nasal passages causing sinus
                      infections{" "}
                    </h6>
                  </Grid>

                  <Grid item xs={4}>
                    <Controller
                      name="intestinalissues"
                      {...register("intestinalissues")}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          size="small"
                          variant="standard"
                          {...field}
                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={4} style={{ marginTop: "10px" }}>
                    <h6>GI/ Stomach/Intestinal issues</h6>
                  </Grid>

                  <Grid
                    item
                    xs={5}
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginRight: "10px",
                    }}
                  >
                    <Controller
                      name="latexAllergy"
                      {...register("latexAllergy")}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          size="small"
                          variant="standard"
                          {...field}
                          fullWidth
                        />
                      )}
                    />
                    <Typography sx={{ whiteSpace: "nowrap" }}>
                      Latex allergy{" "}
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    xs={5}
                    style={{
                      marginTop: "10px",
                      marginBottom: "10px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginLeft: "20px",
                    }}
                  >
                    <Typography sx={{ whiteSpace: "nowrap" }}>
                      Other (state reason):
                    </Typography>

                    <Controller
                      name="other"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          size="small"
                          variant="standard"
                          {...field}
                          fullWidth
                          style={{ flexGrow: 1 }}
                        />
                      )}
                    />
                  </Grid>
                </>
              )}
            </>
          )}
        </Grid>

        <Grid
          container
          spacing={3}
       
          sx={{
            p: 3,
            backgroundColor: "#f8f9fa",
            borderRadius: 2,
            width: "100%",
            mx: "auto",
          }}
        >
          <Grid item xs={12}>
            <Typography
              variant="h6"
              fontWeight="bold"
              color="primary"
              gutterBottom
            >
              Sleep Study History
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <Typography variant="body2" >
                Previous sleep study
              </Typography>
              <input
                type="radio"
                checked={prevSleep ? true : false}
                onClick={(e) => {
                  console.log("checked value", e);
                  setValue("previousSleepStudy", true);
                  setPrevSleep(true);
                }}
              />{" "}
              Yes
              <input
                type="radio"
                checked={prevSleep ? false : true}
                onClick={(e) => {
                  setValue("previousSleepStudy", false);
                  setPrevSleep(false);
                }}
              />{" "}
              No
            </div>
          </Grid>

            <Grid item xs={6}>
            <Controller
              name="ahiScore"
              {...register("ahiScore")}
              control={control}
              render={({ field }) => (
                <TextField
                  size="small"
                  label="If yes, note AHI score"
                  type="number"
                  variant="standard"
                  {...field}
                  fullWidth
                />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography
              variant="caption"
              sx={{ fontStyle: "italic", color: "#666" }}
            >
              (If you do not know & have a copy, please provide to the front
              desk)
            </Typography>
          </Grid>
        </Grid>

        {/* Oral Sleep Appliance */}
        <Grid
          container
          spacing={3}
           sx={{
            p: 3,
            backgroundColor: "#f8f9fa",
            borderRadius: 2,
            width: "100%",
            mx: "auto",
          }}
        >
          <Grid item xs={12}>
            <Typography
              variant="h6"
              fontWeight="bold"
              color="primary"
              gutterBottom
            >
              Oral Sleep Appliance
            </Typography>
          </Grid>

          {/* Tried oral sleep appliance */}
          <Grid item xs={12}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <Typography variant="body2" >
                Have you tried an Oral Sleep appliance in the past?
              </Typography>
              <input
                type="radio"
                checked={oralSleepAppl ? true : false}
                onClick={(e) => {
                  console.log("checked value", e);
                  setValue("oralSleepAppliance", true);
                  setOralSleepAppl(true);
                }}
              />{" "}
              Yes
              <input
                type="radio"
                checked={oralSleepAppl ? false : true}
                onClick={(e) => {
                  setValue("oralSleepAppliance", false);
                  setOralSleepAppl(false);
                }}
              />{" "}
              No
            </div>
          </Grid>

            <Grid item xs={6}>
            <Controller
              name="oralSleepYear"
              {...register("oralSleepYear")}
              control={control}
              render={({ field }) => (
                <TextField
                  size="small"
                  variant="outlined"
                  label="If yes, what year?"
                  {...field}
                  fullWidth
                />
              )}
            />
          </Grid>
        </Grid>

        {/* Other Therapies */}
        <Grid
          container
          spacing={3}
             sx={{
            p: 3,
            backgroundColor: "#f8f9fa",
            borderRadius: 2,
            width: "100%",
            mx: "auto",
          }}
        >
          <Grid item xs={12}>
            <Typography
              variant="h6"
              fontWeight="bold"
              color="primary"
              gutterBottom
            >
              Other Attempted Therapies
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Please comment about other therapy attempts and how each impacted
              your snoring, apnea, and sleep quality
            </Typography>

            <Controller
              name="otherTherapiesComments"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Comments"
                  fullWidth
                  variant="outlined"
                  size="small"
                  multiline
                  rows={3}
                />
              )}
            />
          </Grid>
        </Grid>

        {/* Epworth Sleepiness Scale */}
        <Grid
          container
          spacing={3}
            sx={{
            p: 3,
            backgroundColor: "#f8f9fa",
            borderRadius: 2,
            width: "100%",
            mx: "auto",
          }}
        >
          <Grid item xs={12}>
            <Typography
              variant="h5"
              align="center"
              fontWeight="bold"
              color="primary"
              gutterBottom
            >
              EPWORTH SLEEPINESS SCALE - TO BE COMPLETED BY THE PATIENT
            </Typography>

            <Typography variant="body2" align="center" sx={{ mb: 3 }}>
              How likely are you to doze off or fall asleep in the following
              situations (in contrast to just feeling tired)? Even if you
              haven't been in some of these situations recently, try to work out
              how they may affect you. Choose the most appropriate number for
              each situation:
            </Typography>

            {/* Scale Legend */}
            <Grid
              container
              spacing={2}
              sx={{ mb: 3, p: 2, backgroundColor: "white", borderRadius: 1 }}
            >
              {[
                "0 - NEVER doze",
                "1 - SLIGHT chance",
                "2 - MODERATE chance",
                "3 - HIGH chance",
              ].map((label, idx) => (
                <Grid item xs={12} sm={6} md={3} key={idx}>
                  <Typography variant="body2" fontWeight="bold" color="primary">
                    {label}
                  </Typography>
                </Grid>
              ))}
            </Grid>

            {/* Sitting and reading */}
            <Grid container alignItems="center" spacing={2} sx={{ mb: 1 }}>
                <Grid item xs={6}>
                <Typography variant="body2">Sitting and reading</Typography>
              </Grid>
                <Grid item xs={6}>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <div style={{ display: "flex", gap: 15 }}>
                    <input
                      type="radio"
                      value="0"
                      name="sittingAndReading"
                      checked={sitReading === "0"}
                      onClick={() => {
                        setValue("sittingAndReading", "0");
                        setSitReading("0");
                      }}
                    />
                    0
                    <input
                      type="radio"
                      value="1"
                      name="sittingAndReading"
                      checked={sitReading === "1"}
                      onClick={() => {
                        setValue("sittingAndReading", "1");
                        setSitReading("1");
                      }}
                    />
                    1
                    <input
                      type="radio"
                      value="2"
                      name="sittingAndReading"
                      checked={sitReading === "2"}
                      onClick={() => {
                        setValue("sittingAndReading", "2");
                        setSitReading("2");
                      }}
                      style={{
                        transform: "scale(1.0)",
                      }}
                    />
                    2
                    <input
                      type="radio"
                      value="3"
                      name="sittingAndReading"
                      checked={sitReading === "3"}
                      onClick={() => {
                        setValue("sittingAndReading", "3");
                        setSitReading("3");
                      }}
                    />
                    3
                  </div>
                </RadioGroup>
              </Grid>
            </Grid>

            {/* Watching TV */}
            <Grid container alignItems="center" spacing={2} sx={{ mb: 1 }}>
                <Grid item xs={6}>
                <Typography variant="body2">Watching TV</Typography>
              </Grid>

                <Grid item xs={6}>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <div style={{ display: "flex", gap: 15 }}>
                    <input
                      type="radio"
                      value="0"
                      name="watchingTV"
                      {...register("watchingTV")}
                    />
                    0
                    <input
                      type="radio"
                      value="1"
                      name="watchingTV"
                      {...register("watchingTV")}
                    />
                    1
                    <input
                      type="radio"
                      value="2"
                      name="watchingTV"
                      {...register("watchingTV")}
                    />
                    2
                    <input
                      type="radio"
                      value="3"
                      name="watchingTV"
                      {...register("watchingTV")}
                    />
                    3
                  </div>
                </RadioGroup>
              </Grid>
            </Grid>

            {/* Sitting, inactive in a public place */}
            <Grid container alignItems="center" spacing={2} sx={{ mb: 1 }}>
                <Grid item xs={6}>
                <Typography variant="body2">
                  Sitting, inactive in a public place (i.e., theatre, meeting)
                </Typography>
              </Grid>
                <Grid item xs={6}>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <div style={{ display: "flex", gap: 15 }}>
                    <input
                      type="radio"
                      value="0"
                      name="sittingInactivePlace"
                      {...register("sittingInactivePlace")}
                    />
                    0
                    <input
                      type="radio"
                      value="1"
                      name="sittingInactivePlace"
                      {...register("sittingInactivePlace")}
                    />
                    1
                    <input
                      type="radio"
                      value="2"
                      name="sittingInactivePlace"
                      {...register("sittingInactivePlace")}
                    />
                    2
                    <input
                      type="radio"
                      value="3"
                      name="sittingInactivePlace"
                      {...register("sittingInactivePlace")}
                    />
                    3
                  </div>
                </RadioGroup>
              </Grid>
            </Grid>

            {/* As a passenger in a car */}
            <Grid container alignItems="center" spacing={2} sx={{ mb: 1 }}>
                <Grid item xs={6}>
                <Typography variant="body2">
                  As a passenger in a car for an hour, without break
                </Typography>
              </Grid>
                <Grid item xs={6}>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <div style={{ display: "flex", gap: 15 }}>
                    <input
                      type="radio"
                      value="0"
                      name="passengerCar"
                      {...register("passengerCar")}
                    />
                    0
                    <input
                      type="radio"
                      value="1"
                      name="passengerCar"
                      {...register("passengerCar")}
                    />
                    1
                    <input
                      type="radio"
                      value="2"
                      name="passengerCar"
                      {...register("passengerCar")}
                    />
                    2
                    <input
                      type="radio"
                      value="3"
                      name="passengerCar"
                      {...register("passengerCar")}
                    />
                    3
                  </div>
                </RadioGroup>
              </Grid>
            </Grid>

            {/* Laying to rest */}
            <Grid container alignItems="center" spacing={2} sx={{ mb: 1 }}>
                <Grid item xs={6}>
                <Typography variant="body2">
                  Laying to rest in the afternoon, when circumstances permit
                </Typography>
              </Grid>
                <Grid item xs={6}>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <div style={{ display: "flex", gap: 15 }}>
                    <input
                      type="radio"
                      value="0"
                      name="layingToRest"
                      {...register("layingToRest")}
                    />
                    0
                    <input
                      type="radio"
                      value="1"
                      name="layingToRest"
                      {...register("layingToRest")}
                    />
                    1
                    <input
                      type="radio"
                      value="2"
                      name="layingToRest"
                      {...register("layingToRest")}
                    />
                    2
                    <input
                      type="radio"
                      value="3"
                      name="layingToRest"
                      {...register("layingToRest")}
                    />
                    3
                  </div>
                </RadioGroup>
              </Grid>
            </Grid>

            {/* Sitting and talking to someone */}
            <Grid container alignItems="center" spacing={2} sx={{ mb: 1 }}>
                <Grid item xs={6}>
                <Typography variant="body2">
                  Sitting and talking to someone
                </Typography>
              </Grid>
                <Grid item xs={6}>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <div style={{ display: "flex", gap: 15 }}>
                    <input
                      type="radio"
                      value="0"
                      name="sittingAndTalking"
                      {...register("sittingAndTalking")}
                    />
                    0
                    <input
                      type="radio"
                      value="1"
                      name="sittingAndTalking"
                      {...register("sittingAndTalking")}
                    />
                    1
                    <input
                      type="radio"
                      value="2"
                      name="sittingAndTalking"
                      {...register("sittingAndTalking")}
                    />
                    2
                    <input
                      type="radio"
                      value="3"
                      name="sittingAndTalking"
                      {...register("sittingAndTalking")}
                    />
                    3
                  </div>
                </RadioGroup>
              </Grid>
            </Grid>

            {/* Sitting quietly after lunch */}
            <Grid container alignItems="center" spacing={2} sx={{ mb: 1 }}>
                <Grid item xs={6}>
                <Typography variant="body2">
                  Sitting quietly after lunch when NO Alcohol has been consumed
                </Typography>
              </Grid>
                <Grid item xs={6}>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <div style={{ display: "flex", gap: 15 }}>
                    <input
                      type="radio"
                      value="0"
                      name="sittingQuietly"
                      {...register("sittingQuietly")}
                    />
                    0
                    <input
                      type="radio"
                      value="1"
                      name="sittingQuietly"
                      {...register("sittingQuietly")}
                    />
                    1
                    <input
                      type="radio"
                      value="2"
                      name="sittingQuietly"
                      {...register("sittingQuietly")}
                    />
                    2
                    <input
                      type="radio"
                      value="3"
                      name="sittingQuietly"
                      {...register("sittingQuietly")}
                    />
                    3
                  </div>
                </RadioGroup>
              </Grid>
            </Grid>

            {/* In a car, stationary for a few minutes in traffic */}
            <Grid container alignItems="center" spacing={2} sx={{ mb: 1 }}>
                <Grid item xs={6}>
                <Typography variant="body2">
                  In a car, stationary for a few minutes in traffic
                </Typography>
              </Grid>
                <Grid item xs={6}>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <div style={{ display: "flex", gap: 15 }}>
                    <input
                      type="radio"
                      value="0"
                      name="carStationary"
                      {...register("carStationary")}
                    />
                    0
                    <input
                      type="radio"
                      value="1"
                      name="carStationary"
                      {...register("carStationary")}
                    />
                    1
                    <input
                      type="radio"
                      value="2"
                      name="carStationary"
                      {...register("carStationary")}
                    />
                    2
                    <input
                      type="radio"
                      value="3"
                      name="carStationary"
                      {...register("carStationary")}
                    />
                    3
                  </div>
                </RadioGroup>
              </Grid>
            </Grid>

            {/* Total Score */}
            <Grid
              container
              spacing={2}
              sx={{ mt: 4, p: 2, backgroundColor: "#e8f5e8", borderRadius: 1 }}
            >
                <Grid item xs={6}>
                <Typography variant="h6" fontWeight="bold">
                  Total Score (0-24):
                </Typography>
              </Grid>
                <Grid item xs={6}>
                <TextField
                  value={Total}
                  fullWidth
                  variant="outlined"
                  size="small"
                  InputProps={{ readOnly: true }}
                  sx={{ backgroundColor: "white" }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Signature Section */}
        <Grid
          container
          spacing={3}
            sx={{
            p: 3,
            backgroundColor: "#f8f9fa",
            borderRadius: 2,
            width: "100%",
            mx: "auto",
          }}
        >
          <Grid item xs={12}>
            <Typography
              variant="h6"
              fontWeight="bold"
              color="primary"
              gutterBottom
            >
              Patient Acknowledgement
            </Typography>
          </Grid>
          <Grid item xs={12} md={12}>
            <Controller
              name="patientName"
              control={control}
              render={({ field }) => (
                <TextField
                  label="Patient Name"
                  fullWidth
                  variant="standard"
                   value={
                    props.callingFrom == "Patient" ||
                    props.callingFrom == "OSARequest" || props.callingFrom == "Images"
                      ? patientName
                      : patName
                  }
                  size="small"
                  InputProps={{ readOnly: true }}
                />
              )}
            />
          </Grid>
            <Grid item xs={6}>
            <Controller
              name="patientSignature"
              {...register("patientSignature")}
              control={control}
              render={({ field }) => (
                <TextField
                  size="small"
                  label="Patient Signature"
                  variant="outlined"
                  {...field}
                  fullWidth
                />
              )}
            />
          </Grid>

            <Grid item xs={6}>
            <Controller
              name="sleepinessDate"
              {...register("sleepinessDate")}
              control={control}
              render={({ field }) => (
                <TextField
                  label="Date"
                  type="date"
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={datee}
                  onChange={(e) => {
                    setValue("sleepinessDate", e.target.value);
                    setDatee(e.target.value);
                  }}
                />
              )}
            />
          </Grid>
        </Grid>
      </Grid>

        {/* Submit Button */}
          {props.callingFrom !='Images' &&(
        <Grid container justifyContent="flex-end" sx={{p:1 }}>
          <Button
            onClick={handleSubmit(onSubmit)}
            variant="gradient"
            disabled={submitting}
            sx={{
              backgroundColor: "#A574FD",
              color: "white",
              minWidth: 120,
              height: 40,
              "&:hover": {
                backgroundColor: "#8A5CE6",
              },
            }}
          >
            {submitting ? "Saving..." : "Save"}
          </Button>
        </Grid>
          )}
    </Container>
  );
};

export default OSAPAGE;
